import * as yup from 'yup';

function formName(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'FORM_NAME_IS_REQUIRED',
        defaultMessage: 'Form Name is required',
      }),
    )
    .max(
      32,
      formatMessage({
        id: 'EDITFORM_FORMNAME_FIELD_MAX_CHARS_32',
        defaultMessage: 'Form Name should be less than 32 chars',
      }),
    );
}

function checkOrder(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'CHECK_ORDER_IS_REQUIRED',
        defaultMessage: 'Check Order is required',
      }),
    )
    .max(
      3,
      formatMessage({
        id: 'EDITFORM_CHECKORDER_FIELD_MAX_CHARS_3',
        defaultMessage: 'Check Order should be less than 3 chars',
      }),
    );
}

function formUiSchema(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'FORM_UI_SCHEMA_IS_REQUIRED',
      defaultMessage: 'Form Ui Schema is required',
    }),
  );
}

function defaultValues(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'DEFAULT_VALUES_IS_REQUIRED',
      defaultMessage: 'Default Values is required',
    }),
  );
}

function claimUiSchema(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CLAIM_UI_SCHEMA_IS_REQUIRED',
      defaultMessage: 'Claim Ui Schema is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      formName: formName(formatMessage),
      checkOrder: checkOrder(formatMessage),
      formUiSchema: formUiSchema(formatMessage),
      defaultValues: defaultValues(formatMessage),
      claimUiSchema: claimUiSchema(formatMessage),
    })
    .required();

export default validationSchema;
